// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"bea3c597","183":"14fa44b0","233":"09e08633","419":"6a361be7","453":"04c79a43","469":"a800597b","906":"0329a072"}[chunkId] + ".chunk.js";
};